import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ArticlePreview() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100/60">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-14 items-center">
          <div className="w-full lg:w-[55%]">
            <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-medium text-accent-700 bg-accent-50 mb-4 whitespace-nowrap">
              {t("article.tag")}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              {t("article.title")}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-xl">
              {t("article.summary")}
            </p>
            <div className="flex flex-wrap items-center gap-4 mb-5">
              <span className="text-xs text-foreground-500 flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-calendar-check-line text-accent-500"></i>
                </div>
                {t("article.updated")}
              </span>
              <span className="text-xs text-foreground-500 flex items-center gap-1.5">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-shield-check-line text-accent-500"></i>
                </div>
                {t("article.verified")}
              </span>
            </div>
            <button
              onClick={() => {
                navigate("/artykul/usfans-spreadsheet-przewodnik");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("article.readMore")}
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>

          <div className="w-full lg:w-[45%]">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%20with%20laptop%20showing%20colorful%20spreadsheet%20dashboard%2C%20notebook%20and%20pen%20on%20wooden%20desk%2C%20warm%20natural%20light%20streaming%20through%20window%2C%20small%20succulent%20plant%2C%20productive%20creative%20vibe%2C%20editorial%20photography%2C%20soft%20shadows&width=800&height=600&seq=article-featured-preview&orientation=landscape"
                alt="USFans Spreadsheet Przewodnik"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-black/15 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}